'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes');

var GrabbagActionCreators = {
  addGrabbagItem(filePath) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.ADD_GRABBAG_ITEM,
      filePath: filePath
    });
  },

  updateGrabbagItem(filePath, data) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.UPDATE_GRABBAG_ITEM,
      filePath: filePath,
      data: data
    });
  },

  deleteGrabbagItem(filePathOrItemId) {
    var filePath,
        itemId;

    if (typeof filePathOrItemId === 'string') {
      itemId = filePathOrItemId;
    } else {
      filePath = filePathOrItemId;
    }

    AppDispatcher.handleViewAction({
      type: ActionTypes.DELETE_GRABBAG_ITEM,
      filePath: filePath,
      itemId: itemId
    });
  }
};

module.exports = GrabbagActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/GrabbagActionCreators.js
 **/